// extracted by mini-css-extract-plugin
export default {"opacity":"styles_opacity__i2S1Q"};